import React from "react";
import { Button } from "@mantine/core";
import { useHistory } from "react-router-dom";

const ThankyouPage = () => {
  const history = useHistory();

  return (
    <div
      className="container pt-5"
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <h4 className="text-brand">Thank you!</h4>
      <p>We appreciate you sending us your feedback.</p>
      <Button
        onClick={() => history.push("/")}
        radius="md"
        size="md"
        className="btn btn-design btn-primary mt-5"
      >
        Home
      </Button>
    </div>
  );
};

export default ThankyouPage;
